export const INSTAGRAM_HOST: 'instagram.com' = 'instagram.com' as const;
export const MENTION_SYMBOL: '@' = '@' as const;
export const EMPTY: '' = '' as const;
